import { getDownTime, getSingleDownTimeData } from 'services/axios/downTime'
import { getMasterGlobalTypeList } from 'services/axios/config'

export const actions = {
  GET_DOWN_TIME_LIST: 'GET_DOWN_TIME_LIST',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  GET_DEPARTMENT: 'GET_DEPARTMENT',
  HANDLE_STATUS: 'HANDLE_STATUS',
  GET_SINGLE_DOWNTIME_RECORD: 'GET_SINGLE_DOWNTIME_RECORD',
  HANDLE_DOWNTIME_EMP_SEARCH: 'HANDLE_DOWNTIME_EMP_SEARCH',
}

export const getDownTimeList = ({ status, skip, limit, moduleId, employeeFilter }) => {
  return async (dispatch) => {
    const response = await getDownTime({ status, skip, limit, moduleId, employeeFilter })
    dispatch({
      type: actions.GET_DOWN_TIME_LIST,
      payload: {
        downTimeList: response?.data?.data,
        totalCount: response?.data?.data?.totalCount,
      },
    })
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}
export const handleStatus = (status) => {
  return {
    type: 'HANDLE_STATUS',
    status,
  }
}
export const handleSearchEmployee = (emp) => {
  return {
    type: actions.HANDLE_DOWNTIME_EMP_SEARCH,
    payload: emp,
  }
}
export const getDep = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('department')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const department = response?.data?.data
      dispatch({
        type: actions.GET_DEPARTMENT,
        payload: department,
      })
    }
  }
}

export const getSingleDownTimeRecord = (id, moduleId) => {
  return async (dispatch) => {
    const response = await getSingleDownTimeData(id, moduleId)

    if (response?.status === 200) {
      const responseData = response?.data?.data || {}

      dispatch({
        type: actions.GET_SINGLE_DOWNTIME_RECORD,
        payload: {
          approvalHistory: responseData?.approvalHistory || responseData?.isExist || [],
          // Mirrors Leave Approval's getSingleLeaveRequestRecord - the backend already computes
          // this (downTimeController.js's getSingleRequestDatainDT), it just never reached the
          // frontend before.
          finalAction: responseData?.finalAction || null,
        },
      })
    }
  }
}
